export const pattern13Data = [
  {
    id: 1,
    koreanChunks: [
      "존슨 씨는",
      "수집할 예정이다",
      "피드백을",
      "지난 분기의 성과 보고서로부터",
      "그리고 요약할 것이다.",

      "다음 월요일까지",
    ],
    englishChunks: [
      "Mr. Johnson",
      "will gather",
      "feedback",
      "from last quarter's performance report",
      "and summarize it",
      "by next Monday.",
    ],
    fullEnglish:
      "Mr. Johnson will gather feedback from last quarter's performance report and summarize it by next Monday.",
    explanation: "미래 시제 - 미래에 일어날 예정된 행동이나 계획을 표현합니다.",
  },
  {
    id: 2,
    koreanChunks: [
      "잊지 마세요",
      "챙기는 것을 물을",
      "이 트레킹을 위해",
      "트레킹이 걸릴 예정이기 때문에 ",
      "거의 다섯 시간이",
      "완료하는 데",
    ],
    englishChunks: [
      "Don't forget",
      "to bring some water",
      "for the trek",
      "as it will take",
      "nearly five hours",
      "to finish.",
    ],
    fullEnglish:
      "Don't forget to bring some water for the trek as it will take nearly five hours to finish.",
    explanation: "명령문과 미래 시제가 포함된 복합 문장입니다.",
  },
  {
    id: 3,
    koreanChunks: [
      "시의회는",
      "시작했다",
      "검토를",
      "조사하기 위해",
      "원인을",
      "최근 건물 붕괴",
    ],
    englishChunks: [
      "The city council",
      "initiated",
      "a review",
      "to investigate",
      "the cause",
      "of the recent building collapse.",
    ],
    fullEnglish:
      "The city council initiated a review to investigate the cause of the recent building collapse.",
    explanation: "과거 시제와 부정사구(to investigate)를 사용한 문장입니다.",
  },
  {
    id: 4,
    koreanChunks: [
      "매니저는",
      "빨리 만날 예정이다",
      "파트너들과",
      "그의 런던 출장동안",
    ],
    englishChunks: [
      "The manager",
      "will quickly meet",
      "with partners",
      "during his trip to London.",
    ],
    fullEnglish:
      "The manager will quickly meet with partners during his trip to London.",
    explanation:
      "미래 시제를 사용한 문장으로, 미래에 일어날 행동을 표현합니다.",
  },
  {
    id: 5,
    koreanChunks: [
      "데이비드 김은",
      "가장 영향력 있는 과학자 중 한 명이다",
      "이 분야에서,",
      "기여했음",
      "수많은 획기적인 연구에",
    ],
    englishChunks: [
      "David Kim is",
      "among the most influential scientists",
      " in the field,",
      "having contributed",
      "to numerous groundbreaking studies.",
    ],
    fullEnglish:
      "David Kim is among the most influential scientists in the field, having contributed to numerous groundbreaking studies.",
    explanation:
      "현재 시제와 현재 완료 진행형(having contributed)을 사용한 복합 문장입니다.",
  },
  {
    id: 6,
    koreanChunks: [
      "그 소설은",
      "끝났다",
      "반전으로",
      "그... 남긴",
      "독자들을 매우 감동하게 ",
    ],
    englishChunks: [
      "The novel",
      "ended",
      "with a memorable twist",
      "that left",
      "readers deeply moved.",
    ],
    fullEnglish:
      "The novel ended with a memorable twist that left readers deeply moved.",
    explanation: "과거 시제와 관계대명사절(that left)을 사용한 문장입니다.",
  },
  {
    id: 7,
    koreanChunks: [
      "앤더슨 씨는",
      "충족했다",
      "모든 직무 요건을",
      "그리고",
      "따라서 자격이 있다",
      "승진 될",
      "관리자 직급으로",
    ],
    englishChunks: [
      "Ms. Anderson",
      "satisfied",
      "all the job requirements",
      "and",
      "is therefore qualified",
      "to be promoted ",
      "to a managerial role.",
    ],
    fullEnglish:
      "Ms. Anderson satisfied all the job requirements and is therefore qualified to be promoted to a managerial role.",
    explanation:
      "과거 시제(satisfied)와 현재 시제(is)를 함께 사용하여 인과 관계를 나타내는 복합 문장입니다.",
  },
  {
    id: 8,
    koreanChunks: [
      "어떤 물품",
      "발견된",
      "회의실에서",
      "보관될 것이다",
      "분실물 보관소에",
      "3일 동안",
    ],
    englishChunks: [
      "Any items",
      "discovered",
      "in the conference room",
      "will be stored",
      "in the lost and found",
      "for three days.",
    ],
    fullEnglish:
      "Any items discovered in the conference room will be stored in the lost and found for three days.",
    explanation:
      "수동태(discovered, will be stored)를 사용한 문장으로, 미래 시제를 포함하고 있습니다.",
  },
  {
    id: 9,
    koreanChunks: [
      "수천 대 전기차가",
      "생산되고 있는 중이다",

      "공장에서",
      "현재",
      "충족시키기 위해",
      "증가하는 시장 수요를",
    ],
    englishChunks: [
      "Thousands of new electric vehicles",
      "are being produced",
      "at the factory",
      "right now",
      "to meet",
      "rising market demand.",
    ],
    fullEnglish:
      "Thousands of new electric vehicles are being produced at the factory right now to meet rising market demand.",
    explanation:
      "현재진행형 수동태(are being produced)를 사용하여 현재 진행 중인 행위를 나타내는 문장입니다.",
  },
  {
    id: 10,
    koreanChunks: [
      "지역 회의에서",
      "명확한 합의가 있었다",
      "그....추가 예산이",

      "배정되어야 한다는",
      "지역 학교에",
    ],
    englishChunks: [
      "During the community meeting",
      "there was a clear agreement",
      "that additional funding",

      "should be allocated",
      "to local schools",
    ],
    fullEnglish:
      "During the community meeting, there was a clear agreement that additional funding should be allocated to local schools.",
    explanation:
      "수동태(should be allocated)와 과거 시제(was)를 사용한 복합 문장으로, 간접 화법 구조를 포함하고 있습니다.",
  },
  {
    id: 11,
    koreanChunks: [
      "일정은",
      "연례 과학 박람회를 위한",
      "확정되었다,",
      "그러나 참가자들은",
      "여전히 준비 중이다",
      "그들의 발표를",
    ],
    englishChunks: [
      "The schedule",
      "for the annual science fair",
      "has been finalized,",
      "but participants",
      "are still preparing",
      "their presentations",
    ],
    fullEnglish:
      "The schedule for the annual science fair has been finalized, but participants are still preparing their presentations.",
    explanation:
      "완료형 수동태(has been finalized)와 현재진행형(are preparing)을 사용한 복합 문장으로, 대조를 나타내는 접속사 but을 포함하고 있습니다.",
  },
  {
    id: 12,
    koreanChunks: [
      "그린테크가 엄격한 폐기물 관리정책을 도입했음에도 불구하고",
      "작년에,",

      "많은 직원들이",
      "여전히",
      "따르지못했다",

      "절차를 제대로",
    ],
    englishChunks: [
      "Even though GreenTech introduced a strict waste management policy",
      "last year,",
      "many employees",
      "still",
      "fail to follow",
      "the procedures correctly",
    ],
    fullEnglish:
      "Even though GreenTech introduced a strict waste management policy last year, many employees still fail to follow the procedures correctly.",
    explanation:
      "양보의 접속사(Even though)를 사용한 복합 문장으로, 과거 시제(introduced)와 현재 시제(fail)를 대조적으로 사용하고 있습니다.",
  },
  {
    id: 13,
    koreanChunks: [
      "그녀의 강한 리더십 기술 때문에,",
      "위원회는",
      "간주한다",
      "이 씨를",
      "이상적인 후보자로",

      "이사직을 위한",
    ],
    englishChunks: [
      "Due to her strong leadership skills,",
      "the committee",
      "considers",
      "Ms. Lee",
      "the ideal candidate",
      "for the director position",
    ],
    fullEnglish:
      "Due to her strong leadership skills, the committee considers Ms. Lee the ideal candidate for the director position.",
    explanation:
      "원인을 나타내는 전치사구(Due to)로 시작하는 문장으로, 주어(the committee)와 동사(considers), 목적어(Ms. Lee)와 목적격 보어(the ideal candidate) 구조를 가진 복잡한 문장입니다.",
  },
  {
    id: 14,
    koreanChunks: [
      "엔지니어들은",
      "선보일 것이다",
      "회사의 최신 로봇 기술을",
      "다가오는 기술 전시회에서",
    ],
    englishChunks: [
      "The engineers",
      "will demonstrate",
      "the company's latest robotics technology",
      "at the upcoming tech exhibition",
    ],
    fullEnglish:
      "The engineers will demonstrate the company's latest robotics technology at the upcoming tech exhibition.",
    explanation:
      "미래 시제(will demonstrate)를 사용한 단순 문장으로, 주어(The engineers)와 동사(will demonstrate), 목적어(the company's latest robotics technology)와 장소를 나타내는 부사구(at the upcoming tech exhibition)로 구성되어 있습니다.",
  },
  {
    id: 15,
    koreanChunks: [
      "최근 연구에 따르면,",
      "도시 지역이",
      "겪고 있는 중이다.",
      "더 빈번한 폭염을",
    ],
    englishChunks: [
      "According to recent studies,",
      "urban areas",
      "are experiencing",
      "more frequent heatwaves.",
    ],
    fullEnglish:
      "According to recent studies, urban areas are experiencing more frequent heatwaves.",
    explanation:
      "전치사구(According to)로 시작하는 문장으로, 주어(urban areas)와 현재진행형 동사(are experiencing), 목적어(more frequent heatwaves)로 구성된 단순 문장입니다.",
  },
  {
    id: 16,
    koreanChunks: [
      "유효한 티켓을 가진 누구나 ",
      "자격이 있다",
      "참가할",
      "전국 사진 대회에",
    ],
    englishChunks: [
      "Anyone with a valid ticket",
      "is eligible",
      " to participate",
      "in the National Photography Contest.",
    ],
    fullEnglish:
      "Anyone with a valid ticket is eligible to participate in the National Photography Contest.",
    explanation:
      "주어(Anyone with a valid ticket)와 동사(is eligible to participate), 그리고 전치사구(in the National Photography Contest)로 구성된 단순 문장입니다.",
  },
  {
    id: 17,
    koreanChunks: [
      "모든 제출들이",
      "글로벌 혁신 보조금을 위한",
      "마감된다",
      "3월 15일까지",
    ],
    englishChunks: [
      "All submissions",
      "for the Global Innovation Grant",
      "are due",
      "by March 15.",
    ],
    fullEnglish:
      "All submissions for the Global Innovation Grant are due by March 15.",
    explanation:
      "주어(All submissions)와 전치사구(for the Global Innovation Grant), 동사(are due), 그리고 시간을 나타내는 부사구(by March 15)로 구성된 단순 문장입니다.",
  },
  {
    id: 18,
    koreanChunks: [
      "그 조직은",
      "급격하게 변화했다",
      "전통적인 비영리 단체로부터",

      "첨단 기술 중심의 프로젝트로",
    ],
    englishChunks: [
      "The organization",
      "transformed radically",
      "from a traditional nonprofit",
      "into a modern tech-driven initiative.",
    ],
    fullEnglish:
      "The organization transformed radically from a traditional nonprofit into a modern tech-driven initiative.",
    explanation:
      "주어(The organization)와 동사(transformed radically), 그리고 두 개의 전치사구(from a traditional nonprofit, into a modern tech-driven initiative)로 구성된 단순 문장입니다.",
  },
  {
    id: 19,
    koreanChunks: [
      "소피아 카터는",
      "최연소 감독이다 역대까지",
      "후보로 지명된",
      "골든 프레임 어워드에",
    ],
    englishChunks: [
      "Sophia Carter",
      "is the youngest director ever",
      "to be nominated",
      "for the Golden Frame Award.",
    ],
    fullEnglish:
      "Sophia Carter is the youngest director ever to be nominated for the Golden Frame Award.",
    explanation:
      "주어(Sophia Carter)와 동사(is the youngest director), 부사구(ever to be nominated), 그리고 전치사구(for the Golden Frame Award)로 구성된 단순 문장입니다.",
  },
  {
    id: 20,
    koreanChunks: [
      "참석자는",
      "그..제시하지 못한",
      "유효한 신분증을",
      "접근권한이 부여되지 않을 것이다",
      "행사에",
    ],
    englishChunks: [
      "Attendees",
      "who fail to present",
      "a valid identification card",
      "will not be granted access",
      "to the event.",
    ],
    fullEnglish:
      "Attendees who fail to present a valid identification card will not be granted access to the event.",
    explanation:
      "주어(Attendees)와 관계대명사절(who fail to present a valid identification card), 동사구(will not be granted access), 그리고 전치사구(to the event)로 구성된 단순 문장입니다.",
  },
  {
    id: 21,
    koreanChunks: [
      "리사 파커는",
      "여러 차례 거절했다",
      "초청을",
      "연설하라는",
      "연례 비즈니스 정상회의에서",
    ],
    englishChunks: [
      "Lisa Parker",
      "has repeatedly refused",
      "invitations",
      "to speak",
      "at the annual business summit.",
    ],
    fullEnglish:
      "Lisa Parker has repeatedly refused invitations to speak at the annual business summit.",
    explanation:
      "주어(Lisa Parker)와 동사구(has repeatedly refused), 목적어(invitations), 부정사구(to speak), 그리고 전치사구(at the annual business summit)로 구성된 단순 문장입니다.",
  },
  {
    id: 22,
    koreanChunks: [
      "지난 5년 동안,",
      "중요한 발전이",
      "이루어졌다",
      "재생 에너지 기술에서",
    ],
    englishChunks: [
      "Over the last five years,",
      "significant progress",
      "has been achieved",
      "in renewable energy technology.",
    ],
    fullEnglish:
      "Over the last five years, significant progress has been achieved in renewable energy technology.",
    explanation:
      "부사구(Over the last five years), 주어(significant progress), 동사구(has been achieved), 그리고 전치사구(in renewable energy technology)로 구성된 단순 문장입니다.",
  },
  {
    id: 23,
    koreanChunks: [
      "주어진것 그.. 보증기간이 끝난,",
      "회사는",
      "제공하지 않을 것이다.",
      "무료 교체를",
    ],
    englishChunks: [
      "Given that",
      "the warranty period has ended,",
      "the company",
      "will not provide",
      "free replacements.",
    ],
    fullEnglish:
      "Given that the warranty period has ended, the company will not provide free replacements.",
    explanation:
      "부사구(Given that the warranty period has ended), 주어(the company), 동사구(will not provide), 그리고 목적어(free replacements)로 구성된 단순 문장입니다.",
  },
  {
    id: 24,
    koreanChunks: [
      "그 점원은",
      "매우 미안해했다",
      "주문이 처리되지 않아서 제대로",
    ],
    englishChunks: [
      "The clerk",
      "was very apologetic",
      "since the order was not processed correctly.",
    ],
    fullEnglish:
      "The clerk was very apologetic since the order was not processed correctly.",
    explanation:
      "주어(The clerk), 동사구(was very apologetic), 그리고 부사절(since the order was not processed correctly)로 구성된 단순 문장입니다.",
  },
  {
    id: 25,
    koreanChunks: [
      "모든 박물관 그녀가 방문한 유럽에,",
      "루브르 박물관이",
      "가장 마음에 들었다.",
    ],
    englishChunks: [
      "Of all the museums she visited in Europe,",
      "the Louvre",
      "was her favorite.",
    ],
    fullEnglish:
      "Of all the museums she visited in Europe, the Louvre was her favorite.",
    explanation:
      "전치사구(Of all the museums she visited in Europe), 주어(the Louvre), 그리고 동사구(was her favorite)로 구성된 단순 문장입니다.",
  },
  {
    id: 26,
    koreanChunks: [
      "그 신약은",
      "반드시 거쳐야 한다",
      "광범위한 임상시험을",

      "그 신약이 승인될 수 있기 전에",
      "대중 사용을 위해 ",
    ],
    englishChunks: [
      "The new medication",
      "must undergo",
      "extensive clinical trials",
      "before it can be approved",
      "for public use.",
    ],
    fullEnglish:
      "The new medication must undergo extensive clinical trials before it can be approved for public use.",
    explanation:
      "주어(The new medication), 동사구(must undergo extensive clinical trials), 그리고 부사절(before it can be approved for public use)로 구성된 단순 문장입니다.",
  },
  {
    id: 27,
    koreanChunks: [
      "고객들 그..등록된 회원프로그램에",
      "프로모션 혜택을 받을 수 있다",
      "또한",
      "캐시백도 받을 수 있다.",

      "구매시",
    ],
    englishChunks: [
      "Customers enrolled in the membership program",
      "may take advantage of promotional deals",
      "as well as",
      "earn cashback",
      "on purchases",
    ],
    fullEnglish:
      "Customers enrolled in the membership program may take advantage of promotional deals as well as earn cashback on purchases.",
    explanation:
      "주어(Customers enrolled in the membership program), 동사구(may take advantage of promotional deals as well as earn cashback), 그리고 부사구(on purchases)로 구성된 단순 문장입니다.",
  },
  {
    id: 28,
    koreanChunks: [
      "제임스 휘트먼은",
      "표했다 그의 감사를",
      "그의 팀의 지속적인 헌신에 대해",
      "기조 연설에서",
    ],
    englishChunks: [
      "James Whitman",
      "expressed his gratitude",
      "for his team's continuous dedication",
      "during his keynote address",
    ],
    fullEnglish:
      "During his keynote address, James Whitman expressed his gratitude for his team's continuous dedication.",
    explanation:
      "부사구(During his keynote address), 주어(James Whitman), 동사구(expressed his gratitude), 그리고 전치사구(for his team's continuous dedication)로 구성된 단순 문장입니다.",
  },
  {
    id: 29,
    koreanChunks: [
      "그 항공사는",
      "크게 인하해야 했다",
      "티켓 가격을",

      "늘리기 위해 매출을",
      "지난 분기 동안",
    ],
    englishChunks: [
      "The airline",
      "had to heavily reduce",
      "ticket prices",
      "to boost sales",
      "last quarter",
    ],
    fullEnglish:
      "The airline had to heavily reduce ticket prices to boost sales last quarter.",
    explanation:
      "주어(The airline), 동사구(had to heavily reduce), 목적어(ticket prices), 부사적 용법의 to부정사구(to boost sales), 그리고 시간 부사구(last quarter)로 구성된 단순 문장입니다.",
  },
  {
    id: 30,
    koreanChunks: [
      "연수생들은",
      "일할 것이다",
      "지도 아래에서",
      "선임 프로젝트 매니저",
    ],
    englishChunks: [
      "The trainees",
      "will work",
      "under the guidance",
      "of the senior project manager",
    ],
    fullEnglish:
      "The trainees will work under the guidance of the senior project manager.",
    explanation:
      "주어(The trainees), 동사구(will work), 그리고 전치사구(under the guidance of the senior project manager)로 구성된 단순 문장입니다.",
  },
  {
    id: 31,
    koreanChunks: [
      "직원들 그... 계획하는 사직을",
      "통보해야 한다",
      "상사에게",
      "최소 2주 전에",
    ],
    englishChunks: [
      "Employees who plan to resign",
      "should notify",
      "their supervisor",
      "at least two weeks in advance",
    ],
    fullEnglish:
      "Employees who plan to resign should notify their supervisor at least two weeks in advance.",
    explanation:
      "주어(Employees who plan to resign), 동사구(should notify), 목적어(their supervisor), 그리고 부사구(at least two weeks in advance)로 구성된 단순 문장입니다.",
  },
  {
    id: 32,
    koreanChunks: [
      "이사진들은 렉스코프",
      "회의를 진행하고 있다",
      "관계자들과 제니스 그룹으로부터",
      "그....",
      "그들이 고려했던",
      "협력하는 것을",
    ],
    englishChunks: [
      "The board members of LexCorp",
      "are holding discussions",
      "with officials from Zenith Group,",
      "which",
      "they have considered",
      "partnering with",
    ],
    fullEnglish:
      "The board members of LexCorp are holding discussions with officials from Zenith Group, which they have considered partnering with.",
    explanation:
      "주어(The board members of LexCorp), 동사구(are holding discussions), 전치사구(with officials from Zenith Group), 그리고 관계대명사절(which they have considered partnering with)로 구성된 복합 문장입니다.",
  },
  {
    id: 33,
    koreanChunks: [
      "고대 다리는 강 위에",
      "훼손되었다 상당히",
      "그 다리가 건설된 이후로 200년 전에",
    ],
    englishChunks: [
      "The ancient bridge over the river",
      "has deteriorated considerably",
      "since it was constructed 200 years ago",
    ],
    fullEnglish:
      "The ancient bridge over the river has deteriorated considerably since it was constructed 200 years ago.",
    explanation:
      "주어(The ancient bridge over the river), 동사구(has deteriorated considerably), 접속사(since), 그리고 종속절(it was constructed 200 years ago)로 구성된 복합 문장입니다. 현재완료시제와 수동태를 함께 사용하고 있습니다.",
  },
  {
    id: 34,
    koreanChunks: [
      "엠마 카터는",
      "끝낸 로스쿨을",
      "최고 성적으로",
      "그리고",

      "즉시 채용되었다",
      "명망 있는 법률 회사에",
    ],
    englishChunks: [
      "Emma Carter",
      "completed law school",
      "with top honors",
      "and",
      "was immediately recruited",
      "by a prestigious legal firm",
    ],
    fullEnglish:
      "Emma Carter completed law school with top honors and was immediately recruited by a prestigious legal firm.",
    explanation:
      "주어(Emma Carter), 동사구(completed law school with top honors), 접속사(and), 그리고 수동태 동사구(was immediately recruited by a prestigious legal firm)로 구성된 복합 문장입니다. 능동태와 수동태가 함께 사용되었습니다.",
  },
  {
    id: 35,
    koreanChunks: [
      "검토하는것 다양한 원단 샘플",
      "도움을 줄 수 있다",

      "쇼핑객들이",
      "선택하는데",

      "가장 적합한 소재를",
      "그들의 가구를 위한",
    ],
    englishChunks: [
      "Reviewing different fabric samples",
      "can help",
      "shoppers",
      "select",
      "the most suitable material for",
      "their furniture",
    ],
    fullEnglish:
      "Reviewing different fabric samples can help shoppers select the most suitable material for their furniture.",
    explanation:
      "동명사구(Reviewing different fabric samples)가 주어로 사용된 문장으로, 조동사(can help), 목적어(shoppers), 그리고 부정사구(select the most suitable material for their furniture)로 구성된 복합 문장입니다.",
  },
  {
    id: 36,
    koreanChunks: [
      "관리자는",
      "소통해야 한다",
      "정기적으로",
      "직원들과",
      "보장하기 위해",
      "생산성이 유지되도록 높게",
    ],
    englishChunks: [
      "Supervisors",
      "should communicate",
      "regularly",
      "with employees",
      "to ensure",
      "productivity remains high",
    ],
    fullEnglish:
      "Supervisors should communicate regularly with employees to ensure productivity remains high.",
    explanation:
      "주어(Supervisors), 조동사와 동사(should communicate), 부사(regularly), 전치사구(with employees), 그리고 부정사구(to ensure productivity remains high)로 구성된 문장입니다. 목적을 나타내는 부정사구가 사용되었습니다.",
  },
  {
    id: 37,
    koreanChunks: [
      "콘서트 티켓 소지자는",
      "받을 자격이 있다",
      "전액환불을",
      "행사가 연기된 경우에",
      "또는 취소된",
      "기상 조건으로 인해",
    ],
    englishChunks: [
      "Concert ticket holders",
      "are entitled",
      "to a full refund",
      " provided that the event is postponed",
      "or canceled",
      "due to weather conditions",
    ],
    fullEnglish:
      "Concert ticket holders are entitled to a full refund provided that the event is postponed or canceled due to weather conditions.",
    explanation:
      "주어(Concert ticket holders), 수동태 동사구(are entitled to a full refund), 접속사(provided that), 그리고 조건절(the event is postponed or canceled due to weather conditions)로 구성된 복합 문장입니다. 조건을 나타내는 접속사와 수동태가 함께 사용되었습니다.",
  },
  {
    id: 38,
    koreanChunks: [
      "연구원들은",
      "예상했다",
      "그.. 수요가 전기차에 대한",

      "증가할 것으로 40%까지",
      "향후 5년 동안",
    ],
    englishChunks: [
      "Researchers",
      "have projected",
      "that the demand for electric vehicles",
      "will increase by 40%",
      "over the next five years",
    ],
    fullEnglish:
      "Researchers have projected that the demand for electric vehicles will increase by 40% over the next five years.",
    explanation:
      "주어(Researchers)와 현재완료 동사(have projected), 그리고 that절(that the demand for electric vehicles will increase by 40% over the next five years)로 구성된 복합 문장입니다. 미래 시제(will increase)가 종속절에 사용되었습니다.",
  },
  {
    id: 39,
    koreanChunks: [
      "학생들은",
      "이제 받을 것이다.",
      "혜택을",
      "무제한으로 접근",
      "디지털 학습 자료에",
      "향상시키면서 그들의 학습 경험을",
    ],
    englishChunks: [
      "Students",
      "will now receive",
      "the benefit",
      "of nlimited access",
      "to digital learning resources,",
      "enhancing their study experience",
    ],
    fullEnglish:
      "Students will now receive the benefit of unlimited access to digital learning resources, enhancing their study experience.",
    explanation:
      "주어(Students)와 미래 시제 동사구(will now receive the benefit of), 목적어(unlimited access to digital learning resources), 그리고 분사구문(enhancing their study experience)으로 구성된 문장입니다. 현재분사가 결과나 추가 정보를 제공하는 분사구문으로 사용되었습니다.",
  },
  {
    id: 40,
    koreanChunks: [
      "전통적인 교과서와 달리,",
      "새로운 디지털 버전은",
      "할 수 있게 한다",
      "학생들이",
      "상호작용할 수 있도록",
      "멀티미디어 자료와",
    ],
    englishChunks: [
      "Unlike traditional textbooks,",
      "the new digital edition",
      "allows",
      "students",
      "to interact",
      "with multimedia resources.",
    ],
    fullEnglish:
      "Unlike traditional textbooks, the new digital edition allows students to interact with multimedia resources.",
    explanation:
      "전치사구(Unlike traditional textbooks)로 시작하여 대조를 나타내고, 주어(the new digital edition)와 동사(allows), 목적어(students), 그리고 부정사구(to interact with multimedia resources)로 구성된 문장입니다. 대조와 허용을 나타내는 구조가 사용되었습니다.",
  },
  {
    id: 41,
    koreanChunks: [
      "이 겨울 코트는",

      "40% 더 강하다.",

      "극한 추위에",
      "유사 브랜드보다",
    ],
    englishChunks: [
      "These winter coats",
      "are 40 percent more resistant",
      "to extreme cold",
      "than similar brands.",
    ],
    fullEnglish:
      "These winter coats are 40 percent more resistant to extreme cold than similar brands.",
    explanation:
      "주어(These winter coats)와 동사(are), 비교급 형용사구(40 percent more resistant), 전치사구(to extreme cold), 그리고 비교 대상(than similar brands)으로 구성된 비교 문장입니다. 비교급 구문을 사용하여 두 대상의 특성을 비교하고 있습니다.",
  },
  {
    id: 42,
    koreanChunks: [
      "실업률은 캘리포니아의 ",
      "훨씬 더 낮다",
      "실업률보다 인접한 주들의",
    ],
    englishChunks: [
      "The unemployment rate in California",
      "is much lower",
      "than that in neighboring states.",
    ],
    fullEnglish:
      "The unemployment rate in California is much lower than that in neighboring states.",
    explanation:
      "주어(The unemployment rate in California)와 동사(is), 비교급 형용사구(much lower), 그리고 비교 대상(than that in neighboring states)으로 구성된 비교 문장입니다. 'that'은 앞에 나온 'unemployment rate'를 대신하는 대명사로 사용되었습니다. 비교급 구문을 통해 두 지역의 실업률을 비교하고 있습니다.",
  },
  {
    id: 43,
    koreanChunks: [
      "마쳤음 그들의 식사를",
      "손님들은",

      "떠났다. 식당을 즉시",
      "계산을 하자마자",
    ],
    englishChunks: [
      "Having finished their meal,",
      "the guests",
      "left the restaurant immediately ",
      "upon paying the bill.",
    ],
    fullEnglish:
      "Having finished their meal, the guests left the restaurant immediately upon paying the bill.",
    explanation:
      "분사구문(Having finished their meal)으로 시작하여 시간적 선후관계를 나타내고, 주어(the guests)와 동사(left), 목적어(the restaurant), 그리고 부사구(immediately upon paying the bill)로 구성된 문장입니다. 분사구문과 시간 부사구를 통해 연속된 행동의 순서를 표현하고 있습니다.",
  },
  {
    id: 44,
    koreanChunks: [
      "학생들은",
      "그...",
      "의무가 있는",
      "제출하는 그들의 과제를 늦게",

      "제공해야 한다.",
      "타당한 이유를",
    ],
    englishChunks: [
      "Students",
      "who",
      "are obligated",
      "to submit their assignments late",
      "must provide",
      "a valid reason.",
    ],
    fullEnglish:
      "Students who are obligated to submit their assignments late must provide a valid reason.",
    explanation:
      "주어(Students)와 관계대명사절(who are obligated to submit their assignments late), 조동사와 동사(must provide), 그리고 목적어(a valid reason)로 구성된 문장입니다. 관계대명사절이 주어를 수식하고, 의무를 나타내는 조동사 'must'가 사용되었습니다.",
  },
  {
    id: 45,
    koreanChunks: [
      "소프트웨어 업데이트는",
      "그...",
      "출시된 지난주에",

      "대부분의 사용자가 요청하고 있던 것이다.",
    ],
    englishChunks: [
      "The software update",
      "that",
      "was released last week",
      "is what most users have been requesting.",
    ],
    fullEnglish:
      "The software update that was released last week is what most users have been requesting.",
    explanation:
      "주어(The software update)와 관계대명사절(that was released last week), 동사(is), 그리고 명사절(what most users have been requesting)로 구성된 문장입니다. 관계대명사 'that'은 주어를 수식하고, 'what'으로 시작하는 명사절은 보어 역할을 합니다. 현재완료진행형(have been requesting)을 통해 과거부터 현재까지 계속된 요청을 나타냅니다.",
  },
  {
    id: 46,
    koreanChunks: [
      "전문가들은",
      "예상한다.",
      "제안된 확장이 지하철 시스템 ",

      "개선할 것으로",
      "교통 상황을",
    ],
    englishChunks: [
      "Experts",
      "anticipate",
      "that the proposed expansion of the subway system",
      "will improve",
      "traffic conditions.",
    ],
    fullEnglish:
      "Experts anticipate that the proposed expansion of the subway system will improve traffic conditions.",
    explanation:
      "주어(Experts)와 동사(anticipate), 그리고 목적어 역할을 하는 that절(that the proposed expansion of the subway system will improve traffic conditions)로 구성된 문장입니다. that절 안에는 주어(the proposed expansion of the subway system)와 미래시제 동사(will improve), 목적어(traffic conditions)가 포함되어 있습니다. 예측이나 기대를 나타내는 동사 'anticipate'와 함께 미래 상황을 표현하고 있습니다.",
  },
  {
    id: 47,
    koreanChunks: [
      "자원봉사자들은",
      "열심히 모았다",
      "기금을",
      "자선행사를 위해",
    ],
    englishChunks: [
      "The volunteers",
      "diligently collected",
      "donations",
      "for the charity event.",
    ],
    fullEnglish:
      "The volunteers diligently collected donations for the charity event.",
    explanation:
      "주어(The volunteers), 부사와 동사(diligently collected), 그리고 목적어(donations for the charity event)로 구성된 단순 문장입니다. 부사 'diligently'가 동사를 수식하여 자원봉사자들의 열정적인 활동을 강조하고 있습니다.",
  },
  {
    id: 48,
    koreanChunks: [
      "오랜 대기 시간에 대한 보상으로,",
      "항공사는",
      "제공했다",
      "승객들에게",
      "무료 식사를",
    ],
    englishChunks: [
      "In compensation for the long wait,",
      "the airline",
      "offered",
      "passengers",
      "free meals.",
    ],
    fullEnglish:
      "In compensation for the long wait, the airline offered passengers free meals.",
    explanation:
      "부사구(In compensation for the long wait), 주어(the airline), 동사(offered), 간접목적어(passengers), 그리고 직접목적어(free meals)로 구성된 단순 문장입니다. 전치사구가 문장 앞에 위치하여 항공사가 취한 행동의 이유를 설명하고 있습니다.",
  },
  {
    id: 49,
    koreanChunks: [
      "그 팀의 퍼포먼스가",
      "보여줬다 향상을",
      "몇 주간의 집중 훈련 후",
    ],
    englishChunks: [
      "The team's performance",
      "showed an improvement",
      "after several weeks of intense training.",
    ],
    fullEnglish:
      "The team's performance showed an improvement after several weeks of intense training.",
    explanation:
      "주어(The team's performance), 동사(showed), 목적어(an improvement), 그리고 부사구(after several weeks of intense training)로 구성된 단순 문장입니다. 부사구가 문장 끝에 위치하여 성과 향상이 일어난 시점이나 조건을 설명하고 있습니다.",
  },
  {
    id: 50,
    koreanChunks: [
      "존슨 씨는",
      "상담했다",
      "변호사와",
      "법률 자문을 받기 위해",
      "자신의 사업 계약에 대한",
    ],
    englishChunks: [
      "Mr. Johnson",
      "consulted",
      "a lawyer",
      "to get legal advice",
      "on his business contract.",
    ],
    fullEnglish:
      "Mr. Johnson consulted a lawyer to get legal advice on his business contract.",
    explanation:
      "주어(Mr. Johnson), 동사(consulted), 목적어(a lawyer), 그리고 부사구(to get legal advice on his business contract)로 구성된 단순 문장입니다. 부정사구(to get legal advice)가 목적을 나타내며, 전치사구(on his business contract)가 법률 자문의 주제를 구체화하고 있습니다.",
  },
  {
    id: 51,
    koreanChunks: [
      "방문객들은",
      "입장할 수 있다",
      "박물관에",
      "그러나 그들은 반드시 두어야 한다",
      "그들의 가방을",
      "입구에",
    ],
    englishChunks: [
      "Visitors",
      "are allowed to enter",
      "the museum,",
      "but they must leave",
      "their backpacks",
      "at the entrance.",
    ],
    fullEnglish:
      "Visitors are allowed to enter the museum, but they must leave their backpacks at the entrance.",
    explanation:
      "주어(Visitors)와 두 개의 동사구(are allowed to enter, must leave)를 포함하는 복합 문장입니다. 접속사 'but'이 두 절을 연결하며, 첫 번째 절은 허용을 나타내고 두 번째 절은 의무를 나타냅니다. 목적어(the museum, their backpacks)와 부사구(at the entrance)가 문장을 완성합니다.",
  },
  {
    id: 52,
    koreanChunks: [
      "데이비드는",
      "받지 않았다",
      "장학금을",
      "왜냐하면",
      "그의 지원서가",
      "제출되었기 때문에 늦게",
    ],
    englishChunks: [
      "David",
      "did not receive",
      "the scholarship",
      "because",
      "his application",
      "was submitted late.",
    ],
    fullEnglish:
      "David did not receive the scholarship because his application was submitted late.",
    explanation:
      "주어(David), 동사(did not receive), 목적어(the scholarship), 그리고 부사절(because his application was submitted late)로 구성된 복합 문장입니다. 접속사 'because'가 이유를 나타내는 종속절을 이끌어 주절에서 설명하는 상황의 원인을 제시합니다.",
  },
  {
    id: 53,
    koreanChunks: [
      "그 호텔은",
      "제공했다",
      "무료 조식을",
      "모든 투숙객에게",
      "그들의 숙박 기간 동안",
    ],
    englishChunks: [
      "The hotel",
      "provided",
      "complimentary breakfast",
      "to all guests",
      "during their stay.",
    ],
    fullEnglish:
      "The hotel provided complimentary breakfast to all guests during their stay.",
    explanation:
      "주어(The hotel), 동사(provided), 목적어(complimentary breakfast), 간접목적어(to all guests), 그리고 부사구(during their stay)로 구성된 단순 문장입니다. 이 문장은 호텔이 제공한 서비스와 그 대상, 그리고 시간적 범위를 명확하게 표현하고 있습니다.",
  },
  {
    id: 54,
    koreanChunks: [
      "발표 새로운 회사 정책에 대한",
      "전달되었다",
      "모든 직원들에게",
      "직접",
    ],
    englishChunks: [
      "The announcement for the new company policy",
      "was communicated",
      "to all employees",
      "directly.",
    ],
    fullEnglish:
      "The announcement for the new company policy was communicated directly to all employees.",
    explanation:
      "주어(The announcement for the new company policy), 동사(was communicated), 간접목적어(to all employees), 그리고 부사(directly)로 구성된 수동태 문장입니다. 이 문장은 회사 정책 발표가 어떻게 직원들에게 전달되었는지를 명확하게 표현하고 있습니다.",
  },
  {
    id: 55,
    koreanChunks: [
      "그 회사는",
      "직면했다 강한 비판을",
      "언론으로부터",
      "출시한 후 새로운 광고를 ",
    ],
    englishChunks: [
      "The company",
      "faced strong criticism",
      "from the media",
      "after launching its new advertisement.",
    ],
    fullEnglish:
      "The company faced strong criticism from the media after launching its new advertisement.",
    explanation:
      "주어(The company), 동사(faced), 목적어(strong criticism), 전치사구(from the media), 그리고 부사절(after launching its new advertisement)로 구성된 복합 문장입니다. 이 문장은 회사가 새 광고 출시 이후에 받은 부정적인 반응을 시간적 순서와 함께 명확하게 표현하고 있습니다.",
  },
];
